
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { HelpService } from '@/services'
import Editor from '@/components/editor/index.vue'
@Component({
    components: {
        Editor
    }
})
export default class extends Vue {
    private loading = false
    private isLoading = true
    private typeList: any[] = []
    private form = {
        title: '',
        typeId: -1,
        recommend: 0,
        content: ''
    }
    private rules = {
        title: [{ required: true, message: '请输入分类名称', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        content: [{ required: true, validator: this.contentValidator }]
    }
    get formRef() {
        return this.$refs.createTypeRef as ElForm
    }

    async mounted() {
        this.isLoading = true
        await this.getDetail()
        await this.getList()
    }

    async getDetail() {
        const params = { id: this.$route.params.id }
        const result = await HelpService.getArticleDetail(params)
        if (result.status === 200) {
            this.form.title = result.data.title
            this.form.typeId = result.data.type
            this.form.recommend = result.data.recommend
            this.form.content = result.data.content
        }
    }

    private async getList() {
        const result = await HelpService.getArticleTypes({})
        if (result.status === 200) {
            this.typeList = result.data
        }
    }

    contentValidator(rule: any, value: any, callback: Function) {
        if (!this.form.content) {
            callback(new Error('请输入内容'))
        }
        callback()
    }

    onConfirm() {
        this.formRef.validate(async valid => {
            if (valid) {
                this.loading = true
                await this.onUpdate()
                this.loading = false
            }
        })
    }

    async onUpdate() {
        const params = {
            id: this.$route.params.id,
            type_id: this.form.typeId,
            title: this.form.title,
            content: this.form.content,
            recommend: +this.form.recommend
        }
        const result = await HelpService.updateArticle(params)
        if (result.status === 200) {
            this.$msuccess('修改成功!')
        }
    }

    onContentChange(value: string) {
        this.form.content = value
    }

    onRecommendChange() {
        this.onUpdate()
    }

    onReset() {
        this.formRef.resetFields()
    }
}
